<template>
  <div>
      <keep-alive>
         <router-view></router-view>
      </keep-alive>
        <!-- 底部导航 -->
    <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item icon="search">搜索</van-tabbar-item>
        <van-tabbar-item icon="edit">新增</van-tabbar-item>
        <van-tabbar-item icon="contact">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
    data() {
        return {
            active:0,
            vde:''
        }
    },
    created() {
        if(this.$route.path=='/loginIndex/add') {
            this.active=1
        }else if (this.$route.path=='/loginIndex/user') {
            this.active =2
        }

        if (this.$route.query.vde === undefined) {
            this.vde = "";
        } else {
            this.vde = this.$route.query.vde;
        }


    },
    methods:{
        onChange(e) {
            if (e==0) {
                this.$router.push({path:'/loginIndex?vde=' + this.vde})
            }else if (e==1) {
                this.$router.push({path:'/loginIndex/add?vde=' + this.vde})
            }else if (e==2) {
                this.$router.push({path:'/loginIndex/user?vde=' + this.vde})
            }
        }
    }
}
</script>

<style>

</style>